<div class="steps-panel">

  <!-- ── List mode ─────────────────────────────────────────────────────── -->
  <ng-container *ngIf="!selectedStep">
    <div class="empty-state" *ngIf="steps.steps.length === 0">
      <p>{{ isRecording ? 'Interact with the site to record commands…' : 'Click Record, then interact with the site.' }}</p>
    </div>

    <!-- Saved steps load straight into this same list (loadSavedStep) —
         ordinary, selectable, recordable steps, no separate section. -->
    <div class="step-list" *ngIf="steps.steps.length > 0">
      <div class="step-row" *ngFor="let step of steps.steps" [class.step-row--selected]="isSelected(step)">
        <span class="step-clickzone" (click)="selectStep(step)">
          <span class="step-name">{{ step.name }}</span>
          <span class="step-count">{{ step.commands.length }}</span>
        </span>

        <div class="row-menu" [class.row-menu--open]="isMenuOpen(step)">
          <button class="row-menu-trigger" (click)="toggleMenu(step, $event)">
            <span class="material-symbols-outlined">more_vert</span>
          </button>
          <div class="row-menu-dropdown" *ngIf="isMenuOpen(step)" (click)="$event.stopPropagation()">
            <button (click)="onMenuDelete(step)">Delete Step</button>
            <button (click)="onMenuCopy(step)">Copy Step</button>
            <button (click)="onMenuRename(step)">Rename Step</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ── Detail mode — toolbar lives in ze-simulator-toolbar above. -->
  <ng-container *ngIf="selectedStep">
    <div class="command-list-toolbar">
      <div class="switch-row">
        <label class="switch">
          <input type="checkbox" [(ngModel)]="showEnglishDescription">
          <span class="switch-slider"></span>
        </label>
        <span>English Description</span>
      </div>
    </div>
    <div class="command-list">
      <div class="empty-state" *ngIf="selectedStep.commands.length === 0">
        No commands recorded in this step yet.
      </div>

      <div class="command-row" *ngFor="let c of selectedStep.commands" (contextmenu)="openCommandContextMenu(c.id, $event)">
        <span class="cmd-pill">{{ c.command }}</span>
        <ng-container *ngIf="showEnglishDescription && steps.descriptionFor(c) as cmdDesc; else defaultCmdCols">
          <div class="cmd-english" [title]="cmdDesc">{{ cmdDesc }}</div>
          <button class="row-settings" *ngIf="!isTargetOnlyCommand(c.command)" title="Element details" (click)="onOpenElementDetails(c, $event)">
            <span class="material-symbols-outlined">settings</span>
          </button>
        </ng-container>
        <ng-template #defaultCmdCols>
          <!-- open/selectWindow/close have no real target element. -->
          <ng-container *ngIf="!isTargetOnlyCommand(c.command)">
            <div class="cmd-target" [title]="c.targets[0]">{{ c.title || c.targets[0] || '' }}</div>
            <button class="row-settings" title="Element details" (click)="onOpenElementDetails(c, $event)">
              <span class="material-symbols-outlined">settings</span>
            </button>
          </ng-container>
          <div class="cmd-value" *ngIf="isTargetOnlyCommand(c.command)" [title]="c.targets[0]">{{ c.targets[0] }}</div>
          <div
            class="cmd-value"
            *ngIf="!isTargetOnlyCommand(c.command) && (c.value || c.isPassword) && editingCommandId !== c.id"
            [title]="c.isPassword ? '' : 'Click to edit'"
            (click)="onStartEditValue(c, $event)">{{ c.isPassword ? '••••••' : c.value }}</div>
          <input
            class="cmd-value cmd-value--editing"
            *ngIf="editingCommandId === c.id"
            type="text"
            [(ngModel)]="editingValue"
            (click)="$event.stopPropagation()"
            (keydown.enter)="onSaveEditValue(c)"
            (keydown.escape)="onCancelEditValue()"
            (blur)="onSaveEditValue(c)"
            #valueInput
            autofocus />
        </ng-template>
      </div>
    </div>
  </ng-container>

  <!-- Working equivalent of the page's own (inert here) right-click menu. -->
  <div class="context-menu-overlay" *ngIf="contextMenuArmed">
    <div class="context-menu-panel">
      <div class="context-menu-title">Element selected — choose a command</div>
      <div class="context-menu-hint">The browser's own right-click menu here won't work — pick one below instead.</div>

      <div class="context-menu-tabs">
        <button
          class="context-menu-tab"
          [class.context-menu-tab--active]="contextMenuTab === 'immediate'"
          (click)="contextMenuTab = 'immediate'">Commands</button>
        <button
          class="context-menu-tab"
          [class.context-menu-tab--active]="contextMenuTab === 'delayed'"
          (click)="contextMenuTab = 'delayed'">Delayed Commands</button>
      </div>
      <div class="context-menu-hint context-menu-hint--inline" *ngIf="contextMenuTab === 'delayed'">Completes on whatever you do next on the page (hover, click, etc.) — you have a couple of seconds.</div>

      <div class="context-menu-list">
        <ng-container *ngIf="contextMenuTab === 'immediate'">
          <button *ngFor="let opt of contextMenuCommandsImmediate" (click)="onPickContextMenuCommand(opt.cmd)">{{ opt.label }}</button>
        </ng-container>
        <ng-container *ngIf="contextMenuTab === 'delayed'">
          <button *ngFor="let opt of contextMenuCommandsDelayed" (click)="onPickContextMenuCommand(opt.cmd)">{{ opt.label }}</button>
        </ng-container>
      </div>
      <button class="context-menu-cancel" (click)="onCancelContextMenu()">Cancel</button>
    </div>
  </div>

  <div
    class="command-context-menu"
    *ngIf="commandContextMenu"
    [style.left.px]="commandContextMenu.x"
    [style.top.px]="commandContextMenu.y"
    (click)="$event.stopPropagation()"
    (contextmenu)="$event.preventDefault()">
    <button (click)="onCommandMenuDelete()">Delete Command</button>
    <button (click)="onCommandMenuDeleteAll()">Delete All Commands</button>
    <button (click)="onCommandMenuCopy()">Copy Command</button>
    <button [disabled]="!steps.hasClipboardCommand()" (click)="onCommandMenuPaste()">Paste Command</button>
  </div>

</div>

<div class="toast-container">
  <div class="toast toast--success" *ngIf="toastMessage && toastType === 'success'">{{ toastMessage }}</div>
  <div class="toast toast--error" *ngIf="toastMessage && toastType === 'error'">{{ toastMessage }}</div>
</div>
